import Button from "@/components/atom/Button";
import Label from "@/components/sub-atom/Label";
import Variant from "@/components/sub-atom/Variant";
import { addCarts, revalidateCustom } from "@/functions/databaseData";
import currency from "@/functions/currency";
import useVariantsOption from "@/functions/useVariantsOption";
import useAlert from "@/functions/useAlert";
import {
  CartSolidSvg,
  ChevronLeftSvg,
  MapOutlineSvg,
  MinusSolidSvg,
  PlusSolidSvg,
  SaleSvg,
} from "@/public/svg";
import { usePathname, useRouter } from "next/navigation";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { twMerge } from "tailwind-merge";
import useHitungDiskon from "@/functions/useHitungDiskon";
import Link from "next/link";
import checkLevel from "@/functions/checkLevel";
import generateRandomString from "@/functions/generateRandomString";
import { format } from "date-fns";
import useDelayedRender from "@/functions/useDelayedRender";
import { useQueryClient } from "@tanstack/react-query";

function checkSomeHarga(min, max) {
  return min === max ? currency(max) : `${currency(min)} - ${currency(max)}`;
}
export default function DetailProduct({
  item,
  setSelected,
  profile,
  user,
  carts,
}) {
  const shouldRendered = useDelayedRender(300);
  const queryClient = useQueryClient();
  let path = usePathname();
  const router = useRouter();
  const { showAlert } = useAlert();

  const {
    name_product,
    product_id,
    brand,
    description,
    thumbnails,
    thumbnails_size_cart,
    variants,
  } = item || {};
  const [productSelected, setProductSelected] = useState({
    v1: undefined,
    v2: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [variantSelected, setVariantSelected] = useState();
  const [qty, setQty] = useState(1);

  // Find the minimum and maximum prices among the variants
  const prices = variants?.map((variant) => variant.price_tags);
  const minPrice = Math?.min(...prices);
  const maxPrice = Math?.max(...prices);

  const stock_available = useMemo(() => {
    const allVariantStok =
      variants
        ?.filter((item) => item?.stock >= 0)
        ?.reduce((prev, curr) => {
          return prev + curr.stock;
        }, 0) ?? 0;
    return !variantSelected ? allVariantStok : variantSelected.stock;
  }, [variantSelected, variants]);

  const totalStok = stock_available;

  const variantOptions = useVariantsOption(variants);
  let diskonRange = {
    status: item?.diskon_brand > 0 || item?.diskon_product > 0,
    total: item?.diskon_brand + item?.diskon_product,
  };

  // validasi max total diskon persen
  diskonRange.total = diskonRange.total >= 70 ? 70 : diskonRange.total;

  const diskonSale = {
    status: item?.diskon_brand_nominal > 0 || item?.diskon_product_nominal > 0,
    total: item?.diskon_brand_nominal + item?.diskon_product_nominal,
  };

  let checkUseDiskon = useHitungDiskon(item, variantSelected?.harga);

  const myHarga = checkSomeHarga(minPrice ?? 0, maxPrice ?? 0);
  const totalHarga = !variantSelected?.harga
    ? myHarga
    : currency(parseFloat(checkUseDiskon));

  const newProduct = item?.new_product;
  let listLabelProduct = [
    {
      title: brand?.name_brand,
      type: "brand",
      color: "primary",
    },
  ];
  newProduct &&
    listLabelProduct?.push({
      title: "new",
      type: "other",
      color: "secondary",
    });

  async function handleAddToCart(type = 1) {
    const settingToast = {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    };

    if (!user) {
      return showAlert({
        colors: "warning",
        title: "Produk Gagal Ditambahkan ke Keranjang",
        desc: "silahkan lakukan login terlebih dahulu untuk menambahkan produk ke dalam keranjang",
        descBold: "Login!",
        handleClick: {
          open: {
            hide: true,
          },
          close: {
            onClick: () => router.push("/signin"),
            text: "Login",
            hide: false,
          },
        },
      });
    }

    if (
      !profile?.telephone ||
      !profile?.gender ||
      !profile?.date_of_birth ||
      !profile?.telephone_store ||
      !profile?.name_store ||
      !profile?.address_information?.postal_code
    )
      return showAlert({
        error: true,
        title: "Data akun belum lengkap!!",
        desc: "Produk tidak dapat ditambah ke keranjang, silahkan lengkapi informasi akun terlebih dahulu",
        descBold: "Gagal!",
        handleClick: {
          open: {
            onClick: () => {
              setLoading(true);
              router.push("/member-area/profile-saya");
              setLoading(false);
            },
            text: "Lengkapi data",
            hide: false,
          },
          close: {
            onClick: () => {},
            text: "Batalkan",
            hide: false,
          },
        },
      });

    if (!variantSelected || !variantSelected?.variant_id) {
      return showAlert({
        colors: "error",
        title: "Produk Gagal Ditambahkan ke Keranjang",
        desc: "produk terlebih dahulu sebelum menambahkan ke keranjang",
        descBold: "Pilih variant!",
        handleClick: {
          open: {
            hide: true,
          },
          close: {
            onClick: () => {},
            text: "Pilih variant",
            hide: false,
          },
        },
      });
    }

    setLoading(true);
    try {
      const isSemiBlock = profile?.is_semi_block;
      if (isSemiBlock)
        throw new Error(
          "Maaf, akun tidak bisa melakukan transaksi karena telah diblokir oleh atasan Anda."
        );

      if (!item?.product_id | !variantSelected?.variant_id)
        throw new Error("Maaf, produk atau variant tidak ditemukan!!");

      const variantKey = `${item?.product_id}_${variantSelected?.variant_id}`;
      if (
        carts?.products?.[variantKey]?.jumlah + Number(qty) >
        variantSelected?.stock
      ) {
        return toast.error(
          `Maaf produk ${item?.name_product} melebihi stok pemesanan. Silahkan cek keranjang anda`,
          settingToast
        );
      }

      let kode_order =
        carts?.kode_order?.length > 0
          ? carts?.kode_order
          : `GON${format(Date.now(), "yy-MM-dd")?.replaceAll("-", "")}_${format(
              Date.now(),
              "hh-mm-ss"
            )?.replaceAll("-", "")}${generateRandomString(3)}`;

      let data = {
        id: user?.cart_id,
        kode_order,
        products: {
          [variantKey]: {
            nama: item.name_product,
            product: item.product_id,
            jumlah: Number(qty),
            promo: "",
          },
        },
        total_pembayaran: Math.round(checkUseDiskon),
        pengiriman: {},
        fee_admin: 0,
        biaya_pengiriman: 0,
        total_tagihan: Math.round(checkUseDiskon),
        total_tagihan_normal: Math.round(variantSelected?.harga),
        total_tagihan_before: 0,
        pakai_asuransi: false,
        weight: variantSelected?.package_weight ?? 1,
        length: variantSelected?.package_length ?? 1,
        height: variantSelected?.package_height ?? 1,
        width: variantSelected?.package_width ?? 1,
        // opsional field
        variantKey,
        qty: Number(qty),
        maxQty: variantSelected?.stock,
        mode: "SHIPPING",
        informasi_pengirim: {
          name: user?.mitra_level < 5 ? user?.username : "nibras official",
          phone: user?.mitra_level < 5 ? user?.telephone : "62811186243",
        },
        type: {
          pembayaran: user?.mitra_level < 5 ? "" : "payment_gateway",
          platform: "web",
          user: checkLevel(user?.mitra_level),
        },
      };

      let res = await addCarts({ body: data });

      queryClient.setQueryData(["carts"], (old) => res);
      setProductSelected();
      setVariantSelected();
      setSelected();
      toast(`Produk ${item?.name_product} berhasil ditambahkan ke Keranjang.`, {
        ...settingToast,
        autoClose: 1000,
      });
      if (type == 2) {
        revalidateCustom({
          path: "/cart",
        });
        const section = document.getElementById("btn-beliSekarang");
        if (section) section.click();
        return;
      }

      revalidateCustom({ path });
    } catch (error) {
      console.log(error.message);
      toast.error(`Error : ${error.message}`, {
        ...settingToast,
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    shouldRendered && (
      <div className="flex w-full flex-col gap-6 relative">
        {totalStok <= 0 && (
          <div className="absolute right-0 ">
            <div className="border border-primaryGON-200/50 -rotate-[35deg] bg-opacity-[0.8] rounded-full w-24 h-24  flex items-center justify-center ">
              <p className="p1-regular text-primaryGON-200 text-opacity-100 ">
                Habis
              </p>
            </div>
          </div>
        )}
        <div className="flex flex-col gap-2">
          <p
            id="nama-produk"
            className="capitalize h4-semiBold text-greyscaleGON-700"
          >
            {name_product}
          </p>
          <div className="flex gap-2 justify-start">
            {listLabelProduct?.map((item, index) => (
              <Link
                key={index}
                aria-label={item?.title}
                as={
                  item?.type == "brand"
                    ? `/search/brand/${item?.title}`
                    : `/search/${item?.title}`
                }
                shallow
                href={
                  item?.type == "brand"
                    ? `/search/brand/${item?.title}`
                    : `/search/${item?.title}`
                }
              >
                <Label title={item?.title} colors={item?.color} />
              </Link>
            ))}
          </div>
        </div>

        {/* harga */}
        <div
          id="harga"
          className="flex flex-col-reverse xs:flex-row gap-2 bg-greyscaleGON-50 p-4 xs:items-center"
        >
          {!variantSelected
            ? null
            : (diskonSale?.status || diskonRange?.status) && (
                <p className="h6-semiBold text-greyscaleGON-400 line-through">
                  {currency(variantSelected?.harga)}
                </p>
              )}
          <div className="flex gap-2 items-center">
            <p className="h5-semiBold text-primaryGON-400">{totalHarga}</p>
            {diskonRange?.status && (
              <div className="flex h-fit justify-start">
                <Label
                  colors="secondary"
                  title={`${diskonRange?.total}%`}
                  icon={(props) => <SaleSvg {...props} />}
                />
              </div>
            )}
          </div>
        </div>

        {totalStok > 0 && (
          <>
            {/* variant 1 */}
            <div id="varian" className="flex-col gap-6">
              <div className="flex flex-col gap-2">
                <p className="p1-medium text-greyscaleGON-700">Pilih varian</p>
                <div className="flex flex-wrap gap-2">
                  {!productSelected?.v1
                    ? Object.keys(variantOptions?.color_values ?? {}).map(
                        (val) => {
                          const deps = variantOptions?.color_values[val];
                          const active = productSelected?.value_2 === val;
                          let stok = deps.reduce(
                            (prev, curr) =>
                              prev + (curr.stock >= 0 ? curr.stock : 0),
                            0
                          );

                          if (stok < 1) {
                            return null;
                          }

                          return (
                            <div key={val}>
                              <Variant
                                title={val}
                                active={active}
                                onClick={() => {
                                  if (active) {
                                    setProductSelected({});
                                    setVariantSelected();
                                    setSelected();
                                    setQty(0);
                                    return;
                                  }
                                  setProductSelected({
                                    v2: deps,
                                    value_2: val,
                                  });
                                  setVariantSelected();
                                  setSelected(deps);
                                  setQty(1);
                                }}
                              />
                            </div>
                          );
                        }
                      )
                    : productSelected?.v1?.map((item, index) => {
                        const active =
                          variantSelected?.color_values === item?.color_values;
                        if (item.stock < 1) {
                          return null;
                        }

                        return (
                          <div key={index}>
                            <Variant
                              title={item?.color_values}
                              active={active}
                              childTitle={[
                                `${item?.stock > 99 ? "99+" : item?.stock} pcs`,
                                !item.berat ? null : `${item.berat} gram`,
                              ]}
                              onClick={() => {
                                if (active) {
                                  setVariantSelected();
                                  setSelected();
                                  setQty(0);
                                  return;
                                }
                                setVariantSelected(item);
                                setSelected(item);
                                setQty(1);
                              }}
                            />
                          </div>
                        );
                      })}
                </div>
              </div>
            </div>

            {/* variant 2 */}
            <div id="size" className="flex flex-col gap-6">
              <div className="flex flex-col gap-2">
                <p className="p1-medium text-greyscaleGON-700">Pilih Size</p>
                <div className="flex flex-wrap gap-2">
                  {!productSelected?.v2
                    ? Object.keys(variantOptions?.size_values ?? {}).map(
                        (val) => {
                          const deps = variantOptions?.size_values[val];
                          const active = productSelected?.value_1 === val;
                          let stok = deps.reduce(
                            (prev, curr) =>
                              prev + (curr.stock >= 0 ? curr.stock : 0),
                            0
                          );

                          if (stok < 1) {
                            return null;
                          }

                          return (
                            <div key={val}>
                              <Variant
                                title={val}
                                active={active}
                                onClick={() => {
                                  if (active) {
                                    setProductSelected({});
                                    setVariantSelected();
                                    setSelected();
                                    setQty(0);
                                    return;
                                  }
                                  setProductSelected({
                                    v1: deps,
                                    value_1: val,
                                  });
                                  setVariantSelected();
                                  setSelected(deps);
                                  setQty(1);
                                }}
                              />
                            </div>
                          );
                        }
                      )
                    : productSelected?.v2?.map((item, index) => {
                        const active =
                          variantSelected?.size_values === item?.size_values;
                        if (item.stock < 1) {
                          return null;
                        }

                        return (
                          <div key={index}>
                            <Variant
                              title={item?.size_values}
                              childTitle={[
                                `${item?.stock > 99 ? "99+" : item?.stock} pcs`,
                                !item.berat ? null : `${item.berat} gram`,
                              ]}
                              active={active}
                              onClick={() => {
                                if (active) {
                                  setVariantSelected();
                                  setSelected();
                                  setQty(0);
                                  return;
                                }
                                setVariantSelected(item);
                                setSelected(item);
                                setQty(1);
                              }}
                            />
                          </div>
                        );
                      })}
                </div>
              </div>
            </div>
          </>
        )}

        {/* jumlah */}
        <div className="flex flex-col gap-2">
          <p className="p1-medium text-greyscaleGON-700">Pilih Jumlah</p>
          <div className="flex gap-4">
            <div
              id="jumlah-produk"
              className="flex items-center justify-between p-2 rounded-lg border border-greyscaleGON-100"
            >
              <div
                onMouseDown={(e) => e.preventDefault()}
                className={twMerge(
                  qty <= 1 && "text-opacity-20",
                  "text-primaryGON-400 cursor-pointer"
                )}
                onClick={() => qty > 1 && setQty((old) => old - 1)}
              >
                <MinusSolidSvg className=" h-7 w-7 xs:h-10 xs:w-10 " />
              </div>
              <input
                className="outline-none text-center z-10 w-[5ch]"
                placeholder="1"
                value={qty}
                onChange={(val) => {
                  const value =
                    val?.target?.value > stock_available
                      ? stock_available
                      : val?.target?.value;
                  setQty(value);
                }}
              />
              <div
                onMouseDown={(e) => e.preventDefault()}
                className={twMerge(
                  qty >= stock_available && "text-opacity-20",
                  "text-primaryGON-400 cursor-pointer"
                )}
                onClick={() =>
                  qty < stock_available && setQty((old) => old + 1)
                }
              >
                <PlusSolidSvg className="h-7 w-7 xs:h-10 xs:w-10" />
              </div>
            </div>
            <div id="stok-tersedia" className="flex w-full gap-1 items-center">
              <p className="p1-regular text-greyscaleGON-600">Stok Tersedia:</p>
              <p className="subheading-medium text-greyscaleGON-600">
                {totalStok}
              </p>
            </div>
          </div>
        </div>

        {/* informasi pengiriman */}
        <div className="flex flex-col gap-2">
          <p className="p1-medium text-greyscaleGON-700">
            Informasi Pengiriman
          </p>
          <div className="flex gap-2">
            <div>
              <MapOutlineSvg className="h-7 w-7 xs:h-10 xs:w-10 text-greyscaleGON-400" />
            </div>
            <div className="flex flex-col">
              <p className="text-button-small text-greyscaleGON-600">
                Produk akan dikirim dari
              </p>
              <p className="p2-medium text-greyscaleGON-600">
                Bekasi
              </p>
            </div>
          </div>
        </div>

        {/* btn submit to cart */}
        <div className="flex flex-col md:flex-row gap-2 pt-6">
          <Button
            id="tambah-keranjang"
            variants="outline"
            label={totalStok > 0 ? "Tambah ke keranjang" : "Kembali"}
            className="flex w-full"
            loading={loading}
            disable={loading}
            onClick={totalStok > 0 ? handleAddToCart : router.back}
            icon={{
              left: (props) =>
                totalStok > 0 ? (
                  <CartSolidSvg {...props} />
                ) : (
                  <ChevronLeftSvg {...props} />
                ),
            }}
          />
          <Link
            id="btn-beliSekarang"
            href={"/cart"}
            shallow
            className="sr-only"
          />
          <Button
            id="beli-sekarang"
            className="flex w-full"
            onClick={() => handleAddToCart(2)}
            disable={totalStok <= 0 || loading}
            label="Beli Sekarang"
            variants="solid"
          />
        </div>
      </div>
    )
  );
}
